import { render, staticRenderFns } from "./CharacterPicker.vue?vue&type=template&id=8fd0993c&scoped=true"
import script from "./CharacterPicker.vue?vue&type=script&lang=js"
export * from "./CharacterPicker.vue?vue&type=script&lang=js"
import style0 from "./CharacterPicker.vue?vue&type=style&index=0&id=8fd0993c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd0993c",
  null
  
)

export default component.exports